/**
 * API Request/Response content types.
 */
export const ContentTypes = {
  json: 'application/json'
}

export default ContentTypes
